import React from 'react';
import { Skeleton } from 'antd';

const TableSkeleton = ({ rows = 5, columns = 3, cellWidth = 120 }) => {
  return (
    <div style={{ display: 'table', width: '100%', borderCollapse: 'collapse' }}>
      {/* Header */}
      <div style={{ display: 'table-header-group', fontWeight: 'bold' }}>
        <div style={{ display: 'table-row' }}>
          {[...Array(columns)].map((_, colIndex) => (
            <div
              key={colIndex}
              style={{
                display: 'table-cell',
                padding: '8px',
                borderBottom: '2px solid #f0f0f0',
                width: cellWidth,
              }}
            >
              <Skeleton.Input active size="small" style={{ width: '80%' }} />
            </div>
          ))}
        </div>
      </div>

      {/* Body */}
      <div style={{ display: 'table-row-group' }}>
        {[...Array(rows)].map((_, rowIndex) => (
          <div
            key={rowIndex}
            style={{ display: 'table-row' }}
          >
            {[...Array(columns)].map((_, colIndex) => (
              <div
                key={colIndex}
                style={{
                  display: 'table-cell',
                  padding: '8px',
                  borderBottom: '1px solid #f0f0f0',
                  width: cellWidth,
                }}
              >
                <Skeleton.Input active size="small" style={{ width: '90%' }} />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TableSkeleton;
